import { render } from "./BrilliantInk.vue?vue&type=template&id=09ff173b&scoped=true"
import script from "./BrilliantInk.vue?vue&type=script&lang=js"
export * from "./BrilliantInk.vue?vue&type=script&lang=js"

import "./BrilliantInk.vue?vue&type=style&index=0&id=09ff173b&lang=scss&scoped=true"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-09ff173b"]])

export default __exports__